import React, { FC } from 'react'

import {
    Typography,
    Link,
} from '@material-ui/core'
import { ReservationCustomer } from '@/types/reservation'

interface Props {
    readonly customer: ReservationCustomer;
    readonly customerId: string;
}

const CustomerInfo: FC<Props> = ({
                                     customer,
                                     customerId,
                                 }) => {
    const firstName = customer.firstName || null
    const lastName = customer.lastName || null

    return (
        <div>
            <h2>Main Guest</h2>
            <Typography>
                Name:
                { ' ' }
                <Link href={ `/customers/${ customerId }` } data-id="customerLink">
                    { `${ firstName } ${ lastName }` }
                </Link>
            </Typography>
        </div>
    )
}

export default CustomerInfo
